<template>
  <v-app style="background-color: #f8f9fb">
    <v-container
      style="background-color: #eee"
      id="financeiro"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-email-multiple"
            title="Mensageria Aniversário"
            color="rgb(71 130 180)"
            style="margin-top: 60px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <!-- Formulário -->
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row style="margin-top: 1rem">
                <!-- Data inicio envio -->
                <v-col cols="12" sm="3" class="py-0">
                  <span>Data inicio envio</span>
                  <v-menu
                    v-model="isDatePickerOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        v-model="mensagem.dataEnvio"
                        label="Data inicio"
                        dense
                        solo-inverted
                        readonly
                        :rules="[(v) => !!v || 'Campo obrigatorio']"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="localSelectedDateISO"
                      @input="handleDateSelection"
                    />
                  </v-menu>
                </v-col>

                <!-- Horario -->
                <v-col cols="12" sm="2" class="py-0">
                  <span>Horario envio</span>
                  <v-text-field
                    type="time"
                    v-model="mensagem.horarioEnvio"
                    dense
                    solo-inverted
                    :rules="[(v) => !!v || 'Campo obrigatorio']"
                  />
                </v-col>

                <!-- Empresa -->
                <v-col cols="12" sm="3" class="py-0">
                  <span>Empresa</span>
                  <v-select
                    :items="filteredEmpresas"
                    v-model="mensagem.empresa"
                    label="Empresa"
                    dense
                    solo-inverted
                    :rules="[(v) => !!v || 'Campo obrigatorio']"
                  />
                </v-col>

                <!-- Forma disparo -->
                <v-col cols="12" sm="2" class="py-0">
                  <span>Forma disparo</span>
                  <v-select
                    :items="['WhatsApp']"
                    v-model="mensagem.formaDisparo"
                    dense
                    solo-inverted
                    :rules="[(v) => !!v || 'Campo obrigatorio']"
                  />
                </v-col>

                <!-- Contrato tipo -->
                <v-col cols="12" sm="3" class="py-0">
                  <span>Contrato tipo</span>
                  <v-select
                    :items="['Cemitérios', 'Planos']"
                    v-model="mensagem.contratoTipo"
                    dense
                    solo-inverted
                    :rules="[(v) => !!v || 'Campo obrigatorio']"
                  />
                </v-col>

                <!-- Tipo aniversario -->
                <v-col cols="12" sm="3" class="py-0">
                  <span>Tipo aniversario</span>
                  <v-select
                    :items="['Óbito', 'Vida']"
                    v-model="mensagem.tipoAniversario"
                    dense
                    solo-inverted
                    :rules="[(v) => !!v || 'Campo obrigatorio']"
                  />
                </v-col>

                <!-- Status -->
                <v-col cols="12" sm="2" class="py-0">
                  <span>Status</span>
                  <v-switch
                    v-model="mensagem.status"
                    item-text="text"
                    item-value="value"
                    dense
                    solo-inverted
                    :rules="[(v) => v !== null || 'Campo obrigatorio']"
                  />
                </v-col>

                <!-- Template -->
                <v-col cols="12" class="py-0">
                  <span>Template</span>

                  <v-select
                    v-model="mensagem.template"
                    :items="activeTemplates"
                    item-text="name"
                    item-value="name"
                    dense
                    solo-inverted
                    hide-details
                    return-object
                    :rules="[(v) => !!v || 'Campo obrigatorio']"
                  />

                  <!-- Preview -->
                  <v-expand-transition>
                    <v-card
                      v-if="mensagem.template"
                      class="mt-3 pa-3"
                      outlined
                      color="grey lighten-5"
                    >
                      <div class="d-flex align-center mb-2">
                        <v-icon small class="mr-2" color="primary"
                          >mdi-message-text-outline</v-icon
                        >
                        <span class="font-weight-bold text-body-2">
                          {{ mensagem.template.name }}
                        </span>
                      </div>

                      <v-divider class="mb-2"></v-divider>

                      <div
                        class="text-body-2"
                        style="white-space: pre-line; line-height: 1.5"
                      >
                        {{ mensagem.template.content }}
                      </div>
                    </v-card>
                  </v-expand-transition>
                </v-col>

                <!-- Botoes -->
                <v-col cols="12" class="py-4 d-flex justify-end">
                  <v-btn
                    outlined
                    small
                    color="primary"
                    @click="limparFormulario"
                    class="mr-4"
                  >
                    <v-icon left>mdi-reload</v-icon>Limpar formulário
                  </v-btn>
                  <v-btn
                    small
                    :loading="loadingCreate"
                    :disabled="!valid"
                    :color="modeEdit ? 'warning' : 'primary'"
                    @click="enviarMensagemLote(mensagem)"
                  >
                    <v-icon left
                      >{{ !modeEdit ? "mdi-plus" : "mdi-reload" }}
                    </v-icon>
                    {{ !modeEdit ? "Novo disparo" : "Atualizar Disparo" }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>

            <!-- Listagem de Mensagens em Lote -->
            <v-divider class="my-6"></v-divider>

            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="listaMensagensAniversario"
                  :loading="loadingLista"
                  no-data-text="Nenhuma regra encontrada"
                  no-results-text="Nenhum resultado encontrado"
                  class="elevation-0"
                >
                  <!-- EMPRESA -->
                  <template v-slot:item.empresa="{ item }">
                    <v-chip small dark :color="getEmpresa(item.empresa)">
                      {{ item.empresa }}
                    </v-chip>
                  </template>

                  <!-- DATA -->
                  <template v-slot:item.dataEnvio="{ item }">
                    {{ item.dataEnvio }}
                  </template>

                  <!-- TEMPLATE -->
                  <template v-slot:item.template="{ item }">
                    <div class="text-truncate" style="max-width: 220px">
                      {{ item.template }}
                    </div>
                  </template>

                  <!-- STATUS -->
                  <template v-slot:item.status="{ item }">
                    <v-chip small dark :color="item.status ? 'green' : 'red'">
                      {{ item.status ? "Ativo" : "Inativo" }}
                    </v-chip>
                  </template>

                  <!-- AÇÕES -->
                  <template v-slot:item.acoes="{ item }">
                    <div class="d-flex align-center justify-space-between">
                      <!-- Detalhes -->
                      <v-btn
                        x-small
                        color="info"
                        class="mb-1"
                        title="Ver detalhes"
                        @click="visualizarDetalhes(item)"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>

                      <!-- Editar -->
                      <v-btn
                        x-small
                        color="primary"
                        class="mb-1"
                        title="Editar"
                        @click="editarItem(item)"
                      >
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>

                      <!-- Ativar / Desativar -->
                      <v-btn
                        x-small
                        :color="item.status ? 'red' : 'green'"
                        :title="item.status ? 'Desativar' : 'Ativar'"
                        @click="alterarStatus(item)"
                      >
                        <v-icon small>
                          {{ item.status ? "mdi-pause" : "mdi-play" }}
                        </v-icon>
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </base-material-card>
        </v-col>
      </v-row>

      <!-- Dialog para visualizar detalhes -->
      <v-dialog v-model="dialogDetalhes" max-width="860px">
        <v-card>
          <!-- HEADER -->
          <v-card-title class="py-2">
            <v-icon left small>mdi-cog-outline</v-icon>
            Regra de Aniversario #{{ mensagemSelecionada.id }}

            <v-spacer />

            <v-chip
              small
              dark
              :color="mensagemSelecionada.status ? 'green' : 'red'"
            >
              {{ mensagemSelecionada.status ? "Ativa" : "Inativa" }}
            </v-chip>
          </v-card-title>

          <v-divider></v-divider>

          <!-- RESUMO RÁPIDO VERTICAL -->
          <v-card-subtitle class="py-2">
            <v-row dense>
              <!-- COLUNA ESQUERDA -->
              <v-col cols="12" sm="6">
                <div class="d-flex align-center mb-2">
                  <v-icon small class="mr-2">mdi-domain</v-icon>
                  <div>
                    <div class="text-caption text--secondary">Empresa</div>
                    <div class="font-weight-medium">
                      {{ mensagemSelecionada.empresa || "-" }}
                    </div>
                  </div>
                </div>

                <div class="d-flex align-center mb-2">
                  <v-icon small class="mr-2">mdi-file-document-outline</v-icon>
                  <div>
                    <div class="text-caption text--secondary">
                      Tipo de Contrato
                    </div>
                    <div class="font-weight-medium">
                      {{ mensagemSelecionada.contratoTipo || "-" }}
                    </div>
                  </div>
                </div>

                <div class="d-flex align-center">
                  <v-icon small class="mr-2">mdi-account-heart-outline</v-icon>
                  <div>
                    <div class="text-caption text--secondary">
                      Tipo de Aniversário
                    </div>
                    <div class="font-weight-medium">
                      {{ mensagemSelecionada.tipoAniversario || "-" }}
                    </div>
                  </div>
                </div>
                <div class="d-flex align-center">
                  <v-icon small class="mr-2"
                    >mdi-text-box-multiple-outline</v-icon
                  >
                  <div>
                    <div class="text-caption text--secondary">
                      Template utilizado
                    </div>
                    <div class="font-weight-medium">
                      {{ mensagemSelecionada.template || "-" }}
                    </div>
                  </div>
                </div>
              </v-col>

              <!-- COLUNA DIREITA -->
              <v-col cols="12" sm="6">
                <div class="d-flex align-center mb-2">
                  <v-icon small class="mr-2">mdi-calendar</v-icon>
                  <div>
                    <div class="text-caption text--secondary">
                      Data de Envio
                    </div>
                    <div class="font-weight-medium">
                      {{
                        formatarDataHora(mensagemSelecionada.dataEnvio) || "-"
                      }}
                    </div>
                  </div>
                </div>

                <div class="d-flex align-center mb-2">
                  <v-icon small class="mr-2">mdi-clock-outline</v-icon>
                  <div>
                    <div class="text-caption text--secondary">Horário</div>
                    <div class="font-weight-medium">
                      {{ mensagemSelecionada.horarioEnvio || "-" }}
                    </div>
                  </div>
                </div>

                <div class="d-flex align-center">
                  <v-icon small class="mr-2">mdi-send</v-icon>
                  <div>
                    <div class="text-caption text--secondary">
                      Canal de Disparo
                    </div>
                    <div class="font-weight-medium">
                      {{ mensagemSelecionada.formaDisparo || "-" }}
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-subtitle>

          <v-card-text>
            <!-- HISTÓRICO DE EXECUÇÃO -->
            <v-divider class="my-4"></v-divider>

            <div
              class="text-subtitle-2 font-weight-medium mb-2 d-flex align-center"
            >
              <v-icon small class="mr-1">mdi-history</v-icon>
              Clientes processados
              <v-chip
                small
                class="ml-2"
                color="blue lighten-4"
                text-color="blue darken-2"
              >
                {{ mensagemSelecionada.detalhes?.length || 0 }}
              </v-chip>
            </div>

            <v-data-table
              dense
              :headers="headersClientes"
              :items="mensagemSelecionada.detalhes || []"
              class="elevation-0 tabela-clientes-dialog"
              :items-per-page="8"
              :footer-props="{ itemsPerPageOptions: [8, 16, 32] }"
            >
              <!-- PESSOA -->
              <template v-slot:item.pessoaEvento="{ item }">
                <div class="linha-principal">
                  {{ item.pessoaEvento }}
                </div>
                <div class="linha-secundaria">
                  {{ item.tipoEvento }} • {{ item.contratoEvento }}
                </div>
              </template>

              <!-- DATA EVENTO -->
              <template v-slot:item.dataEvento="{ item }">
                <span class="text-caption">
                  {{ formatarDataBR(item.dataEvento) }}
                </span>
              </template>

              <!-- TELEFONE -->
              <template v-slot:item.telefoneTitular="{ item }">
                <div class="d-flex align-center">
                  <span class="text-caption">{{ item.telefoneTitular }}</span>
                </div>
              </template>

              <!-- DATA ENVIO -->
              <template v-slot:item.data_envio="{ item }">
                <span class="text-caption grey--text text--darken-1">
                  {{ formatarDataHora(item.data_envio) }}
                </span>
              </template>

              <!-- STATUS -->
              <template v-slot:item.status="{ item }">
                <v-chip
                  x-small
                  dark
                  :color="getStatusColor(item.status)"
                  class="chip-status"
                >
                  {{ item.status }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer />
            <v-btn text @click="dialogDetalhes = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog de Aviso -->
      <v-dialog v-model="dialogAviso" max-width="400px" persistent>
        <v-card>
          <v-card-title
            class="headline"
            :class="avisoConfig.color + ' white--text'"
          >
            <v-icon left>{{ avisoConfig.icon }}</v-icon>
            {{ avisoConfig.title }}
          </v-card-title>
          <v-card-text class="pt-4">
            {{ avisoConfig.message }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :color="avisoConfig.color" @click="dialogAviso = false" text>
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-app>
</template>

<script>
import mensageria from "../../services/mensageria";
import SonaxService from "@/services/sonax";

export default {
  name: "MensageriaLote",

  data() {
    return {
      valid: false,
      loadingCreate: false,
      loadingLista: false,
      isDatePickerOpen: false,
      isTimePickerOpen: false,
      localSelectedDateISO: "",
      dialogDetalhes: false,
      mensagemSelecionada: {},
      dialogAviso: false,
      templates: [],
      avisoConfig: {
        title: "",
        message: "",
        color: "primary",
        icon: "mdi-information",
      },
      modeEdit: false,
      mensagem: {
        contratoTipo: null,
        dataEnvio: null,
        horarioEnvio: "12:00",
        empresa: null,
        formaDisparo: "WhatsApp",
        status: true,
        template: null,
        tipoAniversario: null,
      },
      listaMensagensAniversario: [],
      empresas: [
        "CEMITERIO PREVIDA",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DAS FLORES",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "A FLOR DO CAFÉ",
        "CEMITERIO PREVIDA SAO MIGUEL",
      ],
      headers: [
        { text: "Empresa", value: "empresa", width: "180px" },
        { text: "Contrato", value: "contratoTipo", width: "130px" },
        { text: "Tipo Aniversario", value: "tipoAniversario", width: "140px" },
        { text: "Data Inicio", value: "dataEnvio", width: "130px" },
        { text: "Horario", value: "horarioEnvio", width: "100px" },
        { text: "Disparo", value: "formaDisparo", width: "120px" },
        { text: "Template", value: "template", width: "200px" },
        { text: "Status", value: "status", width: "100px" },
        { text: "Acoes", value: "acoes", width: "120px", sortable: false },
      ],
      headersClientes: [
        { text: "Pessoa", value: "pessoaEvento" },
        { text: "Data do Evento", value: "dataEvento", width: "130px" },
        { text: "Telefone", value: "telefoneTitular", width: "130px" },
        { text: "Data Envio", value: "data_envio", width: "140px" },
        { text: "Status", value: "status", width: "110px" },
      ],
    };
  },

  mounted() {
    this.inicializarData();
    this.carregarLista();
  },
  computed: {
    filteredEmpresas() {
      return this.empresas.filter((empresa) => this.hasPermission(empresa));
    },
    activeTemplates() {
      if (!this.templates || !this.templates.length) return [];

      return this.templates.filter(
        (template) => template.status_broker === "APPROVED",
      );
    },
    telefoneEmpresa() {
      if (!this.mensagem.empresa) {
        return null;
      }

      // Pega a primeira empresa selecionada (ou a última se múltiplas)
      const empresaAtual = this.mensagem.empresa;

      // Mapeamento de empresa para telefone (usando os nomes exatos do filtro)
      const mapeamentoEmpresas = {
        PREVIDA: "558282308177",
        Previda: "558282308177",
        previda: "558282308177",
        "MEMORIAL PARQUE MACEIÓ": "558299289412",
        "MEMORIAL PARQUE MACEIO": "558299289412",
        "Memorial Parque Maceió": "558299289412",
        "Memorial Parque Maceio": "558299289412",
        "Parque das Flores": "558296411028",
        "PARQUE DAS FLORES": "558296411028",
        "CEMITERIO PREVIDA": "558000829000",
        "Cemitério Previda": "558000829000",
        "CEMITERIO PREVIDA SÃO MIGUEL": "558000829000",
        "Cemitério Previda São Miguel": "558000829000",
        "PARQUE DO AGRESTE": "558000829000",
        "Parque do Agreste": "558000829000",
      };

      // Função para normalizar string (remove acentos e converte para maiúscula)
      const normalizar = (str) => {
        return str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toUpperCase();
      };

      // Tenta encontrar correspondência exata primeiro
      if (mapeamentoEmpresas[empresaAtual]) {
        return mapeamentoEmpresas[empresaAtual];
      }

      // Tenta com uppercase
      const empresaUpper = empresaAtual.toUpperCase();
      if (mapeamentoEmpresas[empresaUpper]) {
        return mapeamentoEmpresas[empresaUpper];
      }

      // Tenta com normalização (sem acentos)
      const empresaNormalizada = normalizar(empresaAtual);
      for (const [key, telefone] of Object.entries(mapeamentoEmpresas)) {
        if (normalizar(key) === empresaNormalizada) {
          return telefone;
        }
      }

      // Se não encontrou, verifica se contém palavras-chave
      if (empresaNormalizada.includes("CEMITERIO")) {
        return "558000829000";
      }

      if (
        empresaNormalizada.includes("PARQUE") &&
        empresaNormalizada.includes("AGRESTE")
      ) {
        return "558000829000";
      }

      if (empresaNormalizada.includes("PREVIDA")) {
        return "558282308177";
      }
      if (
        empresaNormalizada.includes("MEMORIAL") &&
        empresaNormalizada.includes("MACEIO")
      ) {
        return "558299289412";
      }
      if (
        empresaNormalizada.includes("PARQUE") &&
        empresaNormalizada.includes("FLORES")
      ) {
        return "558296411028";
      }

      console.warn(
        "Empresa não mapeada:",
        empresaAtual,
        "Sem telefone cadastrado",
      );
      return null;
    },
  },
  watch: {
    "mensagem.empresa"(novaEmpresa, antigaEmpresa) {
      if (!novaEmpresa) return;
      this.fetchTemplates();
    },
  },
  methods: {
    normalizarValorSelect(valor, itens) {
      if (valor == null) return valor;
      if (!Array.isArray(itens) || itens.length === 0) return valor;

      const raw = String(valor).trim();
      if (itens.includes(raw)) return raw;

      const normalize = (s) =>
        String(s)
          .trim()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();

      const alvo = normalize(raw);
      const encontrado = itens.find((i) => normalize(i) === alvo);
      return encontrado != null ? encontrado : raw;
    },

    async fetchTemplates() {
      if (!this.mensagem.empresa) {
        console.warn(
          "Por favor, selecione uma empresa no filtro antes de buscar templates.",
        );
        return;
      }

      this.loadingTemplates = true;
      try {
        const response = await SonaxService.getTemplates(this.telefoneEmpresa);

        if (
          response.data &&
          !response.data.error &&
          response.data.data &&
          response.data.data.brokers &&
          response.data.data.brokers.length > 0
        ) {
          // Procurar o broker que corresponde ao telefoneEmpresa usado na requisição
          let brokerEncontrado = response.data.data.brokers.find(
            (broker) => broker.number === this.telefoneEmpresa,
          );

          // Se não encontrar o broker específico, pegar o primeiro broker que tenha templates
          if (
            !brokerEncontrado ||
            !brokerEncontrado.templates ||
            brokerEncontrado.templates.length === 0
          ) {
            brokerEncontrado = response.data.data.brokers.find(
              (broker) => broker.templates && broker.templates.length > 0,
            );
          }

          // Se encontrou um broker com templates, extrair os templates
          if (
            brokerEncontrado &&
            brokerEncontrado.templates &&
            brokerEncontrado.templates.length > 0
          ) {
            const brokerNumber = brokerEncontrado.number;
            this.templates = brokerEncontrado.templates.map((template) => ({
              ...template,
              brokerNumber,
            }));
            console.log("Templates carregados:", this.templates.length);
          } else {
            this.templates = [];
            console.log(
              "Nenhum template encontrado para o telefone:",
              this.telefoneEmpresa,
            );
          }
        } else {
          this.templates = [];
        }
      } catch (error) {
        console.error("Erro ao buscar templates:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao buscar templates",
          color: "error",
        });
        this.templates = [];
      } finally {
        this.loadingTemplates = false;
      }
    },

    async enviarMensagemLote(item) {
      console.log(item)
      const valid = this.$refs.form.validate();
      if (!valid) {
        return;
      }

      this.loadingCreate = true;

      try {
        const payload = {
          ...item,
          template: item.template?.name || null,
        };
        await mensageria.salvar_mensageria_aniversario(payload);

        this.mostrarAviso(
          "Sucesso!",
          `Regra de mensageria enviada com sucesso`,
          "success",
        );
        this.limparFormulario();
        this.carregarLista();
      } catch (error) {
        console.error("Erro ao enviar mensagem em lote:", error);

        this.mostrarAviso(
          "Erro!",
          error.response?.data?.error || "Erro ao enviar mensagem em lote",
          "error",
        );
      } finally {
        this.loadingCreate = false;
      }
    },

    async carregarLista() {
      this.loadingLista = true;
      try {
        const response = await mensageria.listar_mensageria_aniversario();
        this.listaMensagensAniversario = response.data;
      } catch (error) {
        console.error("Erro ao carregar lista de mensagens em lote:", error);
        this.mostrarAviso(
          "Erro!",
          "Erro ao carregar lista de mensagens em lote",
          "error",
        );
      } finally {
        this.loadingLista = false;
      }
    },

    async visualizarDetalhes(item) {
      try {
        const response = await mensageria.listar_mensageria_aniversario_por_id(
          item.id,
        );
        this.mensagemSelecionada = response.data;
        this.dialogDetalhes = true;
      } catch (error) {
        console.error("Erro ao buscar detalhes:", error);
        this.mostrarAviso(
          "Erro!",
          "Erro ao carregar detalhes da mensagem",
          "error",
        );
      }
    },

    async editarItem(item) {
      if (!item) {
        return;
      }

      try {
        this.modeEdit = true;

        // Monta o objeto mantendo defaults para não deixar campos undefined
        const mensagemEdit = {
          contratoTipo: null,
          dataEnvio: null,
          horarioEnvio: "12:00",
          empresa: null,
          formaDisparo: "WhatsApp",
          status: true,
          template: null,
          tipoAniversario: null,
          ...item,
        };

        // Normaliza strings que precisam bater com os itens dos v-select
        mensagemEdit.formaDisparo = this.normalizarValorSelect(
          mensagemEdit.formaDisparo,
          ["WhatsApp"],
        );
        mensagemEdit.contratoTipo = this.normalizarValorSelect(
          mensagemEdit.contratoTipo,
          ["Cemitérios", "Planos"],
        );
        mensagemEdit.tipoAniversario = this.normalizarValorSelect(
          mensagemEdit.tipoAniversario,
          ["Óbito", "Vida"],
        );

        // O backend geralmente retorna template como string (nome).
        // Como o v-select está com return-object, precisamos setar o objeto.
        const templateNome = item.template ? String(item.template).trim() : null;
        mensagemEdit.template = null;

        // Atribui primeiro para disparar o watch de empresa (carregar templates)
        this.mensagem = mensagemEdit;

        // Garante templates carregados antes de selecionar
        if (this.mensagem.empresa) {
          await this.fetchTemplates();
        }

        if (templateNome && Array.isArray(this.templates) && this.templates.length) {
          const templateObj = this.templates.find(
            (t) => String(t.name).trim() === templateNome,
          );
          if (templateObj) {
            this.mensagem.template = templateObj;
          }
        }
      } catch (error) {
        console.error("Erro ao editar item:", error);
      }
    },

    async alterarStatus(item) {
      const novoStatus = !item.status;

      try {
        // cria copia do objeto
        const payload = { ...item, status: novoStatus };

        await mensageria.salvar_mensageria_aniversario(payload);

        this.carregarLista();
        this.mostrarAviso(
          "Sucesso!",
          `Status alterado para ${novoStatus ? "Ativo" : "Inativo"}`,
          "success",
        );
      } catch (error) {
        console.error("Erro ao alterar status:", error);

        this.mostrarAviso(
          "Erro!",
          "Erro ao alterar status da mensagem",
          "error",
        );
      }
    },

    limparFormulario() {
      this.$refs.form?.resetValidation();
      this.modeEdit = false;
      this.mensagem = {
        contratoTipo: null,
        dataEnvio: null,
        horarioEnvio: "12:00",
        empresa: null,
        formaDisparo: "WhatsApp",
        status: true,
        template: null,
        tipoAniversario: null,
      };

      this.inicializarData();
    },

    filteredTemplates(categoria) {
      return this.templates.filter(
        (template) => template.categoria === categoria,
      );
    },
    hasPermission(empresa) {
      this.user = JSON.parse(sessionStorage.getItem("user"));

      if (this.user.roles.includes("ROLE_ADMIN")) {
        return true;
      } else if (empresa === "Todas") {
        return true;
      } else {
        const requiredRoles = empresa
          .split(",")
          .map(
            (name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_"),
          );

        const hasAnyRequiredRole = requiredRoles.some((role) =>
          this.user.roles.includes(role),
        );
        return hasAnyRequiredRole;
      }
    },
    getTipoIcon(tipo) {
      const t = (tipo || "").toLowerCase();
      if (t.includes("whats")) return "mdi-whatsapp";
      if (t.includes("call") || t.includes("lig")) return "mdi-phone";
      if (t.includes("url") || t.includes("link")) return "mdi-link-variant";
      return "mdi-gesture-tap-button";
    },
    getStatusColor(s) {
      const v = (s || "").toLowerCase();
      if (["ok", "sucesso", "enviado", "ativo"].some((k) => v.includes(k)))
        return "green";
      if (["erro", "falha", "inativo", "cancelado"].some((k) => v.includes(k)))
        return "red";
      return "grey";
    },
    inicializarData() {
      const hoje = new Date();
      const dataFormatada = hoje.toISOString().split("T")[0];
      this.localSelectedDateISO = dataFormatada;
      this.mensagem.dataEnvio = this.formatarDataBR(dataFormatada);
    },
    handleDateSelection() {
      this.mensagem.dataEnvio = this.formatarDataBR(this.localSelectedDateISO);
      this.isDatePickerOpen = false;
    },
    formatarDataBR(dataISO) {
      const [ano, mes, dia] = dataISO.split("-");
      return `${dia}/${mes}/${ano}`;
    },
    formatarDataHora(dataHora) {
      if (!dataHora) return "";

      const data = new Date(dataHora);
      const dia = String(data.getDate()).padStart(2, "0");
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const ano = data.getFullYear();
      const hora = String(data.getHours()).padStart(2, "0");
      const minuto = String(data.getMinutes()).padStart(2, "0");

      return `${dia}/${mes}/${ano} ${hora}:${minuto}`;
    },
    getStatusColor(status) {
      switch (status) {
        case "PENDENTE":
          return "orange";
        case "ENVIADO":
          return "green";
        case "ERRO":
          return "red";
        case "CANCELADO":
          return "grey";
        default:
          return "blue";
      }
    },
    getEmpresa(empresa) {
      switch (empresa) {
        case "PARQUE DAS FLORES":
          return "orange darken-2";
        case "CEMITERIO PREVIDA":
          return "blue lighten-1";
        case "MEMORIAL PARQUE MACEIÓ":
          return "green lighten-1";
        case "PARQUE DO AGRESTE":
          return "cyan lighten-1";
        case "PREVIDA":
          return "blue lighten-1";
        default:
          return "grey";
      }
    },

    mostrarAviso(title, message, type = "info") {
      const config = {
        title: title,
        message: message,
        color: "primary",
        icon: "mdi-information",
      };

      switch (type) {
        case "success":
          config.color = "success";
          config.icon = "mdi-check-circle";
          break;
        case "error":
          config.color = "error";
          config.icon = "mdi-alert-circle";
          break;
        case "warning":
          config.color = "warning";
          config.icon = "mdi-alert";
          break;
        default:
          config.color = "info";
          config.icon = "mdi-information";
      }

      this.avisoConfig = config;
      this.dialogAviso = true;
    },
  },
};
</script>

<style scoped>
.v-data-table >>> .v-data-table__wrapper {
  overflow-x: auto;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tabela-clientes-dialog {
  font-size: 12px;
}

.tabela-clientes-dialog .v-data-table__wrapper td {
  padding: 6px 8px !important;
}

.linha-principal {
  font-weight: 600;
  font-size: 12px;
  line-height: 1.2;
}

.linha-secundaria {
  font-size: 11px;
  color: #757575;
  line-height: 1.1;
}

.chip-status {
  font-size: 10px !important;
  height: 20px;
}
</style>
